import { render, staticRenderFns } from "./Merkato.vue?vue&type=template&id=d7dc560a&scoped=true&"
import script from "./Merkato.vue?vue&type=script&lang=js&"
export * from "./Merkato.vue?vue&type=script&lang=js&"
import style0 from "./Merkato.vue?vue&type=style&index=0&id=d7dc560a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7dc560a",
  null
  
)

export default component.exports